const pcToCountyMap = {
  Aberdeenshire: [
    "AB54",
    "AB53",
    "AB52",
    "AB51",
    "AB43",
    "AB42",
    "AB41",
    "AB36",
    "AB35",
    "AB34",
    "AB33",
    "AB32",
    "AB14",
    "AB13",
    "AB10",
    "AB11",
    "AB12",
    "AB15",
    "AB16",
    "AB21",
    "AB22",
    "AB23",
    "AB24",
    "AB25",
    "AB99",
  ],
  Angus: ["DD11", "DD10", "DD9", "DD8", "DD8", "DD7", "DD1", "DD2", "DD3", "DD4", "DD5"],
  Argyll: [
    "PH50",
    "PH49",
    "PH36",
    "PA38",
    "PA36",
    "PA35",
    "PA34",
    "PA37",
    "PA80",
    "PA33",
    "PA32",
    "PA30",
    "PA31",
    "PA29",
    "PA28",
    "PA24",
    "PA25",
    "PA26",
    "PA27",
    "PA23",
    "PA22",
    "PA21",
  ],
  Avon: [
    "GL9",
    "BS29",
    "BS25",
    "BS22",
    "BS23",
    "BS24",
    "BS21",
    "BS0",
    "BS1",
    "BS2",
    "BS3",
    "BS4",
    "BS5",
    "BS6",
    "BS7",
    "BS8",
    "BS9",
    "BS10",
    "BS11",
    "BS13",
    "BS14",
    "BS15",
    "BS16",
    "BS20",
    "BS30",
    "BS31",
    "BS32",
    "BS34",
    "BS35",
    "BS36",
    "BS37",
    "BS39",
    "BS40",
    "BS41",
    "BS48",
    "BS49",
    "BS80",
    "BS98",
    "BS99",
    "BA3",
    "BA1",
    "BA2",
  ],
  Ayrshire: [
    "PA17",
    "KA29",
    "KA30",
    "KA26",
    "KA25",
    "KA24",
    "KA23",
    "KA22",
    "KA21",
    "KA20",
    "KA19",
    "KA18",
    "KA17",
    "KA16",
    "KA14",
    "KA15",
    "KA13",
    "KA11",
    "KA12",
    "KA10",
    "KA9",
    "KA6",
    "KA7",
    "KA8",
    "KA5",
    "KA4",
    "KA1",
    "KA2",
    "KA3",
  ],
  Banffshire: ["AB56", "AB55", "AB45", "AB44", "AB38", "AB37"],
  Bedfordshire: [
    "SG19",
    "SG18",
    "SG17",
    "SG16",
    "SG15",
    "MK40",
    "MK41",
    "MK42",
    "MK43",
    "MK44",
    "MK45",
    "LU7",
    "LU5",
    "LU6",
    "LU1",
    "LU2",
    "LU3",
    "LU4",
  ],
  Berkshire: [
    "SL6",
    "SL60",
    "SL5",
    "SL4",
    "SL1",
    "SL2",
    "SL3",
    "SL95",
    "RG45",
    "RG40",
    "RG41",
    "RG18",
    "RG19",
    "RG17",
    "RG14",
    "RG20",
    "RG12",
    "RG42",
    "RG1",
    "RG2",
    "RG4",
    "RG5",
    "RG6",
    "RG7",
    "RG8",
    "RG10",
    "RG19",
    "RG30",
    "RG31",
    "GU47",
  ],
  Berwickshire: ["TD14", "TD13", "TD12", "TD10", "TD11", "TD4", "TD3", "TD2"],
  Buckinghamshire: [
    "SL9",
    "SL8",
    "SL7",
    "SL0",
    "MK46",
    "MK18",
    "MK16",
    "MK1",
    "MK2",
    "MK3",
    "MK4",
    "MK5",
    "MK6",
    "MK7",
    "MK8",
    "MK9",
    "MK10",
    "MK11",
    "MK12",
    "MK13",
    "MK14",
    "MK15",
    "MK17",
    "MK19",
    "MK77",
    "HP22",
    "HP27",
    "HP17",
    "HP18",
    "HP19",
    "HP20",
    "HP21",
    "HP22",
    "HP16",
    "HP10",
    "HP11",
    "HP12",
    "HP13",
    "HP14",
    "HP15",
    "HP9",
    "HP8",
    "HP6",
    "HP7",
    "HP5",
  ],
  Caithness: ["KW14", "KW12", "KW7", "KW6", "KW5", "KW2", "KW3", "KW1"],
  Cambridgeshire: [
    "PE27",
    "PE26",
    "PE28",
    "PE29",
    "PE19",
    "PE16",
    "PE15",
    "PE13",
    "PE14",
    "PE1",
    "PE2",
    "PE3",
    "PE4",
    "PE5",
    "PE6",
    "PE7",
    "PE8",
    "PE99",
    "CB6",
    "CB7",
    "CB1",
    "CB2",
    "CB3",
    "CB4",
    "CB5",
    "CB21",
    "CB22",
    "CB23",
    "CB24",
    "CB25",
  ],
  "Channel Islesnot": [
    "JE1",
    "JE2",
    "JE3",
    "JE4",
    "JE5",
    "GY1",
    "GY2",
    "GY3",
    "GY4",
    "GY5",
    "GY6",
    "GY7",
    "GY8",
    "GY9",
    "GY10",
  ],
  Cheshire: [
    "WA16",
    "WA14",
    "WA15",
    "WA13",
    "WA8",
    "WA88",
    "WA7",
    "WA6",
    "WA1",
    "WA2",
    "WA3",
    "WA4",
    "WA5",
    "WA55",
    "SY14",
    "SK16",
    "SK15",
    "SK14",
    "SK10",
    "SK11",
    "SK9",
    "SK9",
    "SK8",
    "SK1",
    "SK2",
    "SK3",
    "SK4",
    "SK5",
    "SK6",
    "SK7",
    "SK12",
    "M33",
    "CW12",
    "CW11",
    "CW10",
    "CW8",
    "CW9",
    "CW7",
    "CW6",
    "CW5",
    "CW1",
    "CW2",
    "CW3",
    "CW4",
    "CW98",
    "CH1",
    "CH2",
    "CH3",
    "CH4",
    "CH70",
    "CH88",
    "CH99",
  ],
  Clackmannanshire: ["FK14", "FK13", "FK12", "FK11", "FK10", "FK10"],
  Cleveland: [
    "TS24",
    "TS25",
    "TS26",
    "TS27",
    "TS22",
    "TS23",
    "TS16",
    "TS17",
    "TS18",
    "TS19",
    "TS20",
    "TS21",
    "TS15",
    "TS14",
    "TS12",
    "TS13",
    "TS10",
    "TS11",
    "TS1",
    "TS2",
    "TS3",
    "TS4",
    "TS5",
    "TS6",
    "TS7",
    "TS8",
    "TS9",
  ],
  Clwyd: [
    "LL28",
    "LL29",
    "LL22",
    "LL21",
    "LL20",
    "LL19",
    "LL17",
    "LL18 ",
    "LL16",
    "LL15",
    "LL11",
    "LL12",
    "LL13",
    "LL14",
    "CH8",
    "CH7",
    "CH7",
    "CH6",
    "CH6",
    "CH5",
  ],
  Cornwall: [
    "TR27",
    "TR26",
    "TR18",
    "TR19",
    "TR20",
    "TR17",
    "TR15",
    "TR16",
    "TR14",
    "TR12",
    "TR13",
    "TR11",
    "TR10",
    "TR9",
    "TR7",
    "TR8",
    "TR6",
    "TR5",
    "TR1",
    "TR2",
    "TR3",
    "TR4",
    "PL35",
    "PL34",
    "PL33",
    "PL32",
    "PL30",
    "PL31",
    "PL29",
    "PL28",
    "PL27",
    "PL25",
    "PL26",
    "PL24",
    "PL23",
    "PL22",
    "PL18",
    "PL18",
    "PL17",
    "PL15",
    "PL14",
    "PL13",
    "PL12",
    "PL10",
    "PL11",
    "EX23",
  ],
  "County Antrim": [
    "BT57",
    "BT56",
    "BT54",
    "BT53",
    "BT42",
    "BT43",
    "BT44",
    "BT41",
    "BT40",
    "BT39",
    "BT38",
    "BT36",
    "BT37",
    "BT58",
    "BT29",
    "BT27",
    "BT28",
    "BT1",
    "BT2",
    "BT3",
    "BT4",
    "BT5",
    "BT6",
    "BT7",
    "BT8",
    "BT9",
    "BT10",
    "BT11",
    "BT12",
    "BT13",
    "BT14",
    "BT15",
    "BT16",
    "BT17",
    "BT29",
  ],
  "County Armagh": ["BT62", "BT63", "BT64", "BT65", "BT66", "BT67", "BT60", "BT61", "BT35"],
  "County Down": [
    "BT34",
    "BT33",
    "BT32",
    "BT31",
    "BT30",
    "BT26",
    "BT25",
    "BT24",
    "BT22",
    "BT23",
    "BT21",
    "BT19",
    "BT20",
    "BT18",
  ],
  "County Durham": [
    "TS29",
    "TS28",
    "SR8",
    "SR7",
    "DL16",
    "DL17",
    "DL16",
    "DL15",
    "DL13",
    "DL14",
    "DL12",
    "DL5",
    "DL4",
    "DL1",
    "DL2",
    "DL3",
    "DL98",
    "DH8",
    "DH9",
    "DH8",
    "DH2",
    "DH3",
    "DH1",
    "DH6",
    "DH7",
    "DH8",
    "DH97",
    "DH98",
    "DH99",
  ],
  "County Fermanagh": ["BT74", "BT92", "BT93", "BT94"],
  "County Londonderry": ["BT55", "BT51", "BT52", "BT49", "BT47", "BT48", "BT46", "BT45"],
  "County Tyrone": ["BT82", "BT81", "BT80", "BT78", "BT79", "BT77", "BT76", "BT75", "BT70", "BT71", "BT69", "BT68"],
  Cumbria: [
    "LA23",
    "LA22",
    "LA21",
    "LA20",
    "LA18",
    "LA19",
    "LA17",
    "LA16",
    "LA14",
    "LA15",
    "LA13",
    "LA14",
    "LA12",
    "LA11",
    "LA10",
    "LA8",
    "LA9",
    "LA7",
    "CA28",
    "CA27",
    "CA26",
    "CA25",
    "CA24",
    "CA23",
    "CA22",
    "CA21",
    "CA20",
    "CA19",
    "CA18",
    "CA17",
    "CA16",
    "CA15",
    "CA14",
    "CA95",
    "CA13",
    "CA12",
    "CA10",
    "CA11",
    "CA9",
    "CA8",
    "CA7",
    "CA1",
    "CA2",
    "CA3",
    "CA4",
    "CA5",
    "CA6",
    "CA99",
  ],
  Derbyshire: [
    "SK22",
    "SK23",
    "SK17",
    "SK13",
    "S40",
    "S41",
    "S42",
    "S43",
    "S44",
    "S45",
    "S49",
    "S32",
    "S33",
    "S18",
    "DE75",
    "DE56",
    "DE55",
    "DE45",
    "DE11",
    "DE12",
    "DE7",
    "DE6",
    "DE5",
    "DE4",
    "DE1",
    "DE3",
    "DE21",
    "DE22",
    "DE23",
    "DE24",
    "DE65",
    "DE72",
    "DE73",
    "DE74",
    "DE99",
  ],
  Devon: [
    "TQ14",
    "TQ12",
    "TQ13",
    "TQ11",
    "TQ9",
    "TQ10",
    "TQ9",
    "TQ8",
    "TQ7",
    "TQ6",
    "TQ5",
    "TQ3",
    "TQ4",
    "TQ1",
    "TQ2",
    "PL21",
    "PL20",
    "PL19",
    "PL16",
    "PL1",
    "PL2",
    "PL3",
    "PL4",
    "PL5",
    "PL6",
    "PL7",
    "PL8",
    "PL9",
    "PL95",
    "EX39",
    "EX38",
    "EX37",
    "EX36",
    "EX35",
    "EX35",
    "EX34",
    "EX34",
    "EX33",
    "EX31",
    "EX32",
    "EX24",
    "EX22",
    "EX21",
    "EX20",
    "EX20",
    "EX19",
    "EX18",
    "EX17",
    "EX16",
    "EX15",
    "EX14",
    "EX13",
    "EX12",
    "EX11",
    "EX10",
    "EX9",
    "EX8",
    "EX7",
    "EX1",
    "EX2",
    "EX3",
    "EX4",
    "EX5",
    "EX6",
  ],
  Dorset: [
    "SP8",
    "SP7",
    "DT11",
    "DT10",
    "DT9",
    "DT8",
    "DT7",
    "DT6",
    "DT5",
    "DT3",
    "DT4",
    "DT1",
    "DT2",
    "BH31",
    "BH23",
    "BH22",
    "BH21",
    "BH20",
    "BH19",
    "BH18",
    "BH12",
    "BH13",
    "BH14",
    "BH15",
    "BH16",
    "BH17",
    "BH1",
    "BH2",
    "BH3",
    "BH4",
    "BH5",
    "BH6",
    "BH7",
    "BH8",
    "BH9",
    "BH10",
    "BH11",
  ],
  Dumfriesshire: ["DG16", "DG14", "DG13", "DG12", "DG11", "DG10", "DG4", "DG3", "DG1", "DG2"],
  Dunbartonshire: ["G84", "G83", "G83", "G82", "G81"],
  Dyfed: [
    "SY25",
    "SY25",
    "SY24",
    "SY24",
    "SY24",
    "SY23",
    "SY23",
    "SY23",
    "SA73",
    "SA72",
    "SA71",
    "SA70",
    "SA69",
    "SA68",
    "SA67",
    "SA66",
    "SA65",
    "SA64",
    "SA63",
    "SA61",
    "SA62",
    "SA48",
    "SA47",
    "SA46",
    "SA48 ",
    "SA45",
    "SA44",
    "SA43",
    "SA42",
    "SA41",
    "SA40",
    "SA39",
    "SA38",
    "SA37",
    "SA36",
    "SA35",
    "SA34",
    "SA31",
    "SA32",
    "SA33",
    "SA20",
    "SA19",
    "SA19",
    "SA19",
    "SA18",
    "SA17",
    "SA17",
    "SA16",
    "SA14",
    "SA15",
  ],
  "East Lothian": ["EH42", "EH41", "EH40", "EH39", "EH36", "EH33", "EH34", "EH35", "EH32", "EH32", "EH31"],
  "East Sussex": [
    "TN39",
    "TN40",
    "TN37",
    "TN38",
    "TN36",
    "TN34",
    "TN35",
    "TN33",
    "TN32",
    "TN31",
    "TN22",
    "TN21",
    "TN20",
    "TN19",
    "TN7",
    "TN6",
    "TN2",
    "TN5",
    "RH18",
    "BN27",
    "BN26",
    "BN25",
    "BN24",
    "BN20",
    "BN21",
    "BN22",
    "BN23",
    "BN10",
    "BN9",
    "BN7",
    "BN8",
    "BN3",
    "BN52",
    "BN1",
    "BN2",
    "BN41",
    "BN42",
    "BN45",
    "BN50",
    "BN51",
    "BN88",
  ],
  Essex: [
    "SS17",
    "SS13",
    "SS14",
    "SS15",
    "SS16",
    "SS11",
    "SS12",
    "SS9",
    "SS8",
    "SS7",
    "SS6",
    "SS5",
    "SS4",
    "SS1",
    "SS2",
    "SS3",
    "SS22",
    "SS99",
    "SS0",
    "SS1",
    "RM19",
    "RM18",
    "RM16",
    "RM17",
    "RM20",
    "RM15",
    "RM14",
    "RM13",
    "RM11",
    "RM12",
    "RM8",
    "RM9",
    "RM10",
    "RM1",
    "RM2",
    "RM3",
    "RM4",
    "RM5",
    "RM6",
    "RM7",
    "IG11",
    "IG10",
    "IG9",
    "IG8",
    "IG7",
    "IG8",
    "IG1",
    "IG2",
    "IG3",
    "IG4",
    "IG5",
    "IG6",
    "EN9",
    "CO15",
    "CO16",
    "CO14",
    "CO13",
    "CO12",
    "CO11",
    "CO9",
    "CO1",
    "CO2",
    "CO3",
    "CO4",
    "CO5",
    "CO6",
    "CO7",
    "CM24",
    "CM17",
    "CM18",
    "CM19",
    "CM20",
    "CM16",
    "CM13",
    "CM14",
    "CM15",
    "CM11",
    "CM12",
    "CM9",
    "CM8",
    "CM7",
    "CM77",
    "CM6",
    "CM7 ",
    "CM5",
    "CM4",
    "CM1",
    "CM2",
    "CM3",
    "CM92",
    "CM98",
    "CM99",
    "CM0",
    "CM0",
    "CB10",
    "CB11",
  ],
  Fife: [
    "KY16",
    "KY14",
    "KY15",
    "KY11",
    "KY11",
    "KY12",
    "KY99",
    "KY10",
    "KY8",
    "KY9",
    "KY6",
    "KY7",
    "KY5",
    "KY4",
    "KY4",
    "KY3",
    "KY1",
    "KY2",
    "DD6",
    "DD6",
  ],
  Gloucestershire: [
    "GL56",
    "GL55",
    "GL50",
    "GL51",
    "GL52",
    "GL53",
    "GL54",
    "GL20",
    "GL18",
    "GL18",
    "GL17",
    "GL17",
    "GL17",
    "GL17",
    "GL17",
    "GL16",
    "GL15",
    "GL15",
    "GL14",
    "GL14",
    "GL14",
    "GL13",
    "GL11",
    "GL12",
    "GL11",
    "GL10",
    "GL8",
    "GL7",
    "GL7",
    "GL7",
    "GL5",
    "GL6",
    "GL1",
    "GL2",
    "GL3",
    "GL4",
    "GL19",
  ],
  Gwent: [
    "NP44",
    "NP26",
    "NP25",
    "NP24",
    "NP23",
    "NP22",
    "NP16",
    "NP15",
    "NP13",
    "NP12",
    "NP10",
    "NP11",
    "NP18",
    "NP19",
    "NP20",
    "NP7",
    "NP4",
  ],
  Gwynedd: [
    "LL78",
    "LL77",
    "LL76",
    "LL75",
    "LL74",
    "LL73",
    "LL72",
    "LL71",
    "LL70",
    "LL69",
    "LL68",
    "LL67",
    "LL66",
    "LL65",
    "LL64",
    "LL77 ",
    "LL63",
    "LL62",
    "LL61",
    "LL60",
    "LL59",
    "LL58",
    "LL57",
    "LL56",
    "LL54",
    "LL55",
    "LL53",
    "LL52",
    "LL51",
    "LL49",
    "LL48",
    "LL47",
    "LL46",
    "LL45",
    "LL44",
    "LL43",
    "LL42",
    "LL41",
    "LL40",
    "LL39",
    "LL38",
    "LL37",
    "LL36",
    "LL35",
    "LL34",
    "LL33",
    "LL31",
    "LL31",
    "LL32",
    "LL30",
    "LL27",
    "LL26",
    "LL25",
    "LL24",
    "LL23",
  ],
  Hampshire: [
    "SP10",
    "SP11",
    "SP6",
    "SO51",
    "SO50",
    "SO53",
    "SO42",
    "SO41",
    "SO40",
    "SO43",
    "SO24",
    "SO21",
    "SO22",
    "SO23",
    "SO25",
    "SO20",
    "SO14",
    "SO15",
    "SO16",
    "SO17",
    "SO18",
    "SO19",
    "SO30",
    "SO31",
    "SO32",
    "SO40",
    "SO45",
    "SO52",
    "SO97",
    "RG28",
    "RG27",
    "RG29",
    "RG26",
    "RG21",
    "RG22",
    "RG23",
    "RG24",
    "RG25",
    "RG28",
    "PO14",
    "PO15",
    "PO16",
    "PO17",
    "PO12",
    "PO13",
    "PO12",
    "PO13",
    "PO11",
    "PO10",
    "PO9",
    "PO9",
    "PO7",
    "PO8",
    "PO4",
    "PO5",
    "PO1",
    "PO2",
    "PO3",
    "PO6",
    "GU51",
    "GU52",
    "GU46",
    "GU35",
    "GU34",
    "GU33",
    "GU31",
    "GU32",
    "GU30",
    "GU14",
    "GU17",
    "GU11",
    "GU12",
    "BH25",
    "BH24",
  ],
  Herefordshire: ["HR9", "HR8", "HR7", "HR6", "HR5", "HR1", "HR2", "HR3", "HR4"],
  Hertfordshire: [
    "WD23",
    "WD17",
    "WD19",
    "WD24",
    "WD25",
    "WD99",
    "WD7",
    "WD6",
    "WD5",
    "WD4",
    "WD18 ",
    "WD3",
    "SG13",
    "SG14",
    "SG11",
    "SG12",
    "SG10",
    "SG9",
    "SG8",
    "SG7",
    "SG6",
    "SG4",
    "SG5",
    "SG6 ",
    "SG3",
    "SG1",
    "SG2",
    "HP23",
    "HP4",
    "HP1",
    "HP2",
    "HP3",
    "EN11",
    "EN10",
    "EN11 ",
    "EN7",
    "EN8",
    "EN77",
    "EN6",
    "EN4",
    "EN5",
    "CM22",
    "CM23",
    "CM21",
    "AL9",
    "AL10",
    "AL7",
    "AL8",
    "AL6",
    "AL7",
    "AL5",
    "AL1",
    "AL2",
    "AL3",
    "AL4",
  ],
  "Inverness-shire": [
    "PH40",
    "PH41",
    "PH39",
    "PH38",
    "PH37",
    "PH35",
    "PH34",
    "PH33",
    "PH32",
    "PH31",
    "PH30",
    "PH25",
    "PH24",
    "PH23",
    "PH22",
    "PH21",
    "PH20",
    "PH19",
    "IV4",
    "IV1",
    "IV2",
    "IV3",
    "IV5",
    "IV13",
    "IV63",
    "IV99",
    "HS8",
  ],
  "Isle of Arran": ["KA27"],
  "Isle of Harris": ["HS3", "HS5"],
  "Isle of Islay": ["PA42", "PA43", "PA44", "PA45", "PA46", "PA47", "PA48", "PA49"],
  "Isle of Jura": ["PA60"],
  "Isle of Mull": [
    "PA62",
    "PA63",
    "PA64",
    "PA65",
    "PA66",
    "PA67",
    "PA68",
    "PA69",
    "PA70",
    "PA71",
    "PA72",
    "PA73",
    "PA74",
    "PA75",
  ],
  "Isle of Rum": ["PH43"],
  "Isle of Skye": ["IV51", "IV41", "IV42", "IV43", "IV44", "IV45", "IV46", "IV47", "IV48", "IV49", "IV55", "IV56"],
  "Isle of Wight": [
    "PO40",
    "PO39",
    "PO38",
    "PO36",
    "PO37",
    "PO36",
    "PO35",
    "PO34",
    "PO33",
    "PO32",
    "PO31",
    "PO30",
    "PO41",
    "PO30",
  ],
  "Isles of Scilly": ["TR21", "TR22", "TR23", "TR24", "TR25"],
  Kent: [
    "TN30",
    "TN29",
    "TN28",
    "TN23",
    "TN24",
    "TN25",
    "TN26",
    "TN27",
    "TN17",
    "TN18",
    "TN16",
    "TN13",
    "TN14",
    "TN15",
    "TN9",
    "TN10",
    "TN11",
    "TN12",
    "TN8",
    "TN1",
    "TN2",
    "TN3",
    "TN4",
    "ME14",
    "ME15",
    "ME16",
    "ME17",
    "ME18",
    "ME99",
    "ME13",
    "ME12",
    "ME11",
    "ME9",
    "ME10",
    "ME7",
    "ME8",
    "ME6",
    "ME19",
    "ME6",
    "ME6",
    "ME20",
    "ME4",
    "ME5",
    "ME1",
    "ME2",
    "ME3",
    "DA17",
    "DA14",
    "DA15",
    "DA11",
    "DA12",
    "DA13",
    "DA10",
    "DA9",
    "DA8",
    "DA18",
    "DA7",
    "DA16",
    "DA6",
    "DA7",
    "DA5",
    "DA3",
    "DA1",
    "DA2",
    "DA4",
    "DA10",
    "CT21",
    "CT18",
    "CT19",
    "CT20",
    "CT50",
    "CT15",
    "CT16",
    "CT17",
    "CT14",
    "CT13",
    "CT11",
    "CT12",
    "CT10",
    "CT9",
    "CT8",
    "CT7",
    "CT9 ",
    "CT6",
    "CT5",
    "CT1",
    "CT2",
    "CT3",
    "CT4",
    "BR8",
    "BR7",
    "BR5",
    "BR6",
    "BR4",
    "BR3",
    "BR2",
    "BR1",
    "BR2",
  ],
  Kincardineshire: ["AB39", "AB31", "AB30"],
  "Kinross-shire": ["KY13"],
  Lanarkshire: [
    "ML12",
    "ML11",
    "ML10",
    "ML9",
    "ML8",
    "ML7",
    "ML6",
    "ML5",
    "ML4",
    "ML3",
    "ML2",
    "ML1",
    "G1",
    "G2",
    "G3",
    "G4",
    "G5",
    "G9",
    "G11",
    "G12",
    "G13",
    "G14",
    "G15",
    "G20",
    "G21",
    "G22",
    "G23",
    "G31",
    "G32",
    "G33",
    "G34",
    "G40",
    "G41",
    "G42",
    "G43",
    "G44",
    "G45",
    "G46",
    "G51",
    "G52",
    "G53",
    "G58",
    "G60",
    "G61",
    "G62",
    "G63",
    "G64",
    "G65",
    "G66",
    "G67",
    "G68",
    "G69",
    "G70",
    "G71",
    "G72",
    "G73",
    "G74",
    "G75",
    "G76",
    "G77",
    "G78",
    "G79",
    "G90",
  ],
  Lancashire: [
    "WN8",
    "WN7",
    "WN1",
    "WN2",
    "WN3",
    "WN4",
    "WN5",
    "WN6",
    "WN8",
    "PR25",
    "PR26",
    "PR6",
    "PR7",
    "PR0",
    "PR1",
    "PR2",
    "PR3",
    "PR4",
    "PR5",
    "PR11",
    "OL15",
    "OL16 ",
    "OL14",
    "OL13",
    "OL11",
    "OL12",
    "OL16",
    "OL10",
    "OL5",
    "OL6",
    "OL7",
    "OL1",
    "OL2",
    "OL3",
    "OL4",
    "OL8",
    "OL9",
    "OL95",
    "M3",
    "M5",
    "M6",
    "M7",
    "M50",
    "M60 ",
    "M1",
    "M2",
    "M3",
    "M4",
    "M8",
    "M9",
    "M11",
    "M12",
    "M13",
    "M14",
    "M15",
    "M16",
    "M17",
    "M18",
    "M19",
    "M20",
    "M21",
    "M22",
    "M23",
    "M24",
    "M25",
    "M26",
    "M27",
    "M28",
    "M29",
    "M30",
    "M31",
    "M32",
    "M34",
    "M35",
    "M38",
    "M40",
    "M41",
    "M43",
    "M44",
    "M45",
    "M46",
    "M60",
    "M61",
    "M90",
    "M99",
    "LA5",
    "LA6",
    "LA3",
    "LA4",
    "LA1",
    "LA2",
    "L39",
    "L40",
    "FY8",
    "FY7",
    "FY6",
    "FY5",
    "FY0",
    "FY1",
    "FY2",
    "FY3",
    "FY4",
    "BL1",
    "BL2",
    "BL3",
    "BL4",
    "BL5",
    "BL6",
    "BL7",
    "BL11",
    "BL78",
    "BL0",
    "BL8",
    "BL9",
    "BB18",
    "BB94",
    "BB10",
    "BB11",
    "BB12",
    "BB9",
    "BB8",
    "BB7",
    "BB5",
    "BB4",
    "BB3",
    "BB1",
    "BB2",
    "BB6",
  ],
  Leicestershire: [
    "LE67",
    "LE67",
    "LE67",
    "LE65",
    "LE18",
    "LE17",
    "LE13",
    "LE14",
    "LE11",
    "LE12",
    "LE10",
    "LE1",
    "LE2",
    "LE3",
    "LE4",
    "LE5",
    "LE6",
    "LE7",
    "LE8",
    "LE9",
    "LE19",
    "LE21",
    "LE41",
    "LE55",
    "LE87",
    "LE94",
    "LE95",
  ],
  "Leicestershire / Rutland": ["LE16", "LE15"],
  Lincolnshire: [
    "PE24",
    "PE25",
    "PE23",
    "PE20",
    "PE21",
    "PE22",
    "PE11",
    "PE12",
    "PE10",
    "PE9",
    "NG34",
    "NG31",
    "NG32",
    "NG33",
    "LN13",
    "LN12",
    "LN11",
    "LN10",
    "LN9",
    "LN7",
    "LN8",
    "LN1",
    "LN2",
    "LN3",
    "LN4",
    "LN5",
    "LN6",
    "DN21",
  ],
  London: [
    "WC1A",
    "WC1B",
    "WC1E",
    "WC1H",
    "WC1N",
    "WC1R",
    "WC1V",
    "WC1X",
    "WC2A",
    "WC2B",
    "WC2E",
    "WC2H",
    "WC2N",
    "WC2R",
    "W1A",
    "W1B",
    "W1C",
    "W1D",
    "W1F",
    "W1G",
    "W1H",
    "W1J",
    "W1K",
    "W1S",
    "W1T",
    "W1U",
    "W1W",
    "W2",
    "W3",
    "W4",
    "W5",
    "W6",
    "W7",
    "W8",
    "W9",
    "W10",
    "W11",
    "W12",
    "W13",
    "W14",
    "SW1A",
    "SW1E",
    "SW1H",
    "SW1P",
    "SW1V",
    "SW1W",
    "SW1X",
    "SW1Y",
    "SW2",
    "SW3",
    "SW4",
    "SW5",
    "SW6",
    "SW7",
    "SW8",
    "SW9",
    "SW10",
    "SW11",
    "SW12",
    "SW13",
    "SW14",
    "SW15",
    "SW16",
    "SW17",
    "SW18",
    "SW19",
    "SW20",
    "SW95",
    "SE1",
    "SE1P",
    "SE2",
    "SE3",
    "SE4",
    "SE5",
    "SE6",
    "SE7",
    "SE8",
    "SE9",
    "SE10",
    "SE11",
    "SE12",
    "SE13",
    "SE14",
    "SE15",
    "SE16",
    "SE17",
    "SE18",
    "SE19",
    "SE20",
    "SE21",
    "SE22",
    "SE23",
    "SE24",
    "SE25",
    "SE26",
    "SE27",
    "SE28",
    "NW1",
    "NW1W",
    "NW2",
    "NW3",
    "NW4",
    "NW5",
    "NW6",
    "NW7",
    "NW8",
    "NW9",
    "NW10",
    "NW11",
    "NW26",
    "N1",
    "N1C",
    "N1P",
    "N2",
    "N3",
    "N4",
    "N5",
    "N6",
    "N7",
    "N8",
    "N9",
    "N10",
    "N11",
    "N12",
    "N13",
    "N14",
    "N15",
    "N16",
    "N17",
    "N18",
    "N19",
    "N20",
    "N21",
    "N22",
    "N81",
    "EC1A",
    "EC1M",
    "EC1N",
    "EC1P",
    "EC1R",
    "EC1V",
    "EC1Y",
    "EC2A",
    "EC2M",
    "EC2N",
    "EC2P",
    "EC2R",
    "EC2V",
    "EC2Y",
    "EC3A",
    "EC3M",
    "EC3N",
    "EC3P",
    "EC3R",
    "EC3V",
    "EC4A",
    "EC4M",
    "EC4N",
    "EC4P",
    "EC4R",
    "EC4V",
    "EC4Y",
    "EC50",
    "E1",
    "E1W",
    "E2",
    "E3",
    "E4",
    "E5",
    "E6",
    "E7",
    "E8",
    "E9",
    "E10",
    "E11",
    "E12",
    "E13",
    "E14",
    "E15",
    "E16",
    "E17",
    "E18",
    "E20",
    "E77",
    "E98",
  ],
  Merseyside: [
    "WA12",
    "WA9",
    "WA10",
    "WA11",
    "PR8",
    "PR9",
    "L34",
    "L35",
    "L20",
    "L30",
    "L69",
    "L80",
    "GIR",
    "L1",
    "L2",
    "L3",
    "L4",
    "L5",
    "L6",
    "L7",
    "L8",
    "L9",
    "L10",
    "L11",
    "L12",
    "L13",
    "L14",
    "L15",
    "L16",
    "L17",
    "L18",
    "L19",
    "L20",
    "L21",
    "L22",
    "L23",
    "L24",
    "L25",
    "L26",
    "L27",
    "L28",
    "L29",
    "L31",
    "L32",
    "L33",
    "L36",
    "L37",
    "L38",
    "L67",
    "L68",
    "L69",
    "L70",
    "L71",
    "L72",
    "L73",
    "L74",
    "L75",
    "CH34",
    "CH65",
    "CH66",
    "CH33",
    "CH64",
    "CH28",
    "CH29",
    "CH30",
    "CH31",
    "CH32",
    "CH46",
    "CH47",
    "CH48",
    "CH49",
    "CH60",
    "CH61",
    "CH62",
    "CH63",
    "CH27",
    "CH44",
    "CH45",
    "CH26",
    "CH43",
    "CH25",
    "CH41",
    "CH42",
  ],
  "Mid Glamorgan": [
    "CF83",
    "CF82",
    "CF81",
    "CF72",
    "CF47",
    "CF48",
    "CF46",
    "CF45",
    "CF44",
    "CF43",
    "CF42",
    "CF41",
    "CF40",
    "CF39",
    "CF37",
    "CF38",
    "CF36",
    "CF34",
    "CF31",
    "CF32",
    "CF33",
    "CF35",
  ],
  Middlesex: [
    "UB9",
    "UB10",
    "UB11",
    "UB7",
    "UB8 ",
    "UB5",
    "UB6",
    "UB18",
    "UB5",
    "UB3",
    "UB4",
    "UB1",
    "UB2",
    "UB3 ",
    "TW18",
    "TW19",
    "TW17",
    "TW16",
    "TW15",
    "TW13",
    "TW14",
    "TW12",
    "TW11",
    "TW8",
    "TW7",
    "TW3",
    "TW4",
    "TW5",
    "TW6",
    "TW1",
    "TW2",
    "HA8",
    "HA7",
    "HA6",
    "HA5",
    "HA4",
    "HA1",
    "HA2",
    "HA3",
    "HA0",
    "HA9",
    "EN1",
    "EN2",
    "EN3",
  ],
  Midlothian: [
    "EH38",
    "EH37",
    "EH28",
    "EH27",
    "EH26",
    "EH25",
    "EH24",
    "EH23",
    "EH22",
    "EH21",
    "EH20",
    "EH19",
    "EH18",
    "EH14",
    "EH14",
    "EH14",
    "EH1",
    "EH2",
    "EH3",
    "EH4",
    "EH5",
    "EH6",
    "EH7",
    "EH8",
    "EH9",
    "EH10",
    "EH11",
    "EH12",
    "EH13",
    "EH14",
    "EH15",
    "EH16",
    "EH17",
    "EH91",
    "EH95",
    "EH99",
  ],
  Morayshire: ["PH26", "IV36", "IV32", "IV31", "IV30"],
  Norfolk: [
    "PE38",
    "PE37",
    "PE36",
    "PE35",
    "PE30",
    "PE31",
    "PE32",
    "PE33",
    "PE34",
    "NR29",
    "NR30",
    "NR31",
    "NR28",
    "NR27",
    "NR26",
    "NR25",
    "NR24",
    "NR23",
    "NR22",
    "NR21",
    "NR19",
    "NR20",
    "NR18",
    "NR17",
    "NR1",
    "NR2",
    "NR3",
    "NR4",
    "NR5",
    "NR6",
    "NR7",
    "NR8",
    "NR9",
    "NR10",
    "NR11",
    "NR12",
    "NR13",
    "NR14",
    "NR15",
    "NR16",
    "NR18",
    "NR19",
    "NR26",
    "NR28",
    "NR99",
    "IP24",
    "IP25",
    "IP26",
    "IP21",
    "IP22",
    "IP98",
    "IP20",
  ],
  "North Humberside": [
    "YO25",
    "YO15",
    "YO16",
    "HU19",
    "HU18",
    "HU17",
    "HU16",
    "HU20",
    "HU15",
    "HU14",
    "HU13",
    "HU1",
    "HU2",
    "HU3",
    "HU4",
    "HU5",
    "HU6",
    "HU7",
    "HU8",
    "HU9",
    "HU10",
    "HU11",
    "HU12",
    "DN14",
  ],
  "North Yorkshire": [
    "YO21",
    "YO22",
    "YO18",
    "YO17",
    "YO14",
    "YO11",
    "YO12",
    "YO13",
    "YO8",
    "YO7",
    "YO1",
    "YO10",
    "YO19",
    "YO23",
    "YO24",
    "YO26",
    "YO30",
    "YO31",
    "YO32",
    "YO41",
    "YO42",
    "YO43",
    "YO51",
    "YO60",
    "YO61",
    "YO62",
    "YO90",
    "YO91",
    "LS24",
    "HG5",
    "HG4",
    "HG1",
    "HG2",
    "HG3",
    "DL10",
    "DL11",
    "DL9",
    "DL8",
    "DL8",
    "DL8",
    "DL6",
    "DL7",
    "BD24",
    "BD23",
    "BD24",
  ],
  Northamptonshire: [
    "NN17",
    "NN18",
    "NN14",
    "NN15",
    "NN16",
    "NN13",
    "NN12",
    "NN11",
    "NN10",
    "NN8",
    "NN9",
    "NN29",
    "NN1",
    "NN2",
    "NN3",
    "NN4",
    "NN5",
    "NN6",
    "NN7",
  ],
  Northumberland: [
    "TD15",
    "TD12",
    "TD12",
    "NE71",
    "NE70",
    "NE68",
    "NE67",
    "NE66",
    "NE69",
    "NE66",
    "NE64",
    "NE63",
    "NE62",
    "NE61",
    "NE65",
    "NE49",
    "NE46",
    "NE47",
    "NE48",
    "NE45",
    "NE44",
    "NE43",
    "NE42",
    "NE41",
    "NE24",
    "NE23",
    "NE22",
  ],
  Nottinghamshire: [
    "S80",
    "S81",
    "NG25",
    "NG22",
    "NG23",
    "NG24",
    "NG18",
    "NG19",
    "NG20",
    "NG21",
    "NG70",
    "NG17",
    "NG1",
    "NG2",
    "NG3",
    "NG4",
    "NG5",
    "NG6",
    "NG7",
    "NG8",
    "NG9",
    "NG10",
    "NG11",
    "NG12",
    "NG13",
    "NG14",
    "NG15",
    "NG16",
    "NG17",
    "NG80",
    "NG90",
    "DN22",
  ],
  Oxfordshire: [
    "SN7",
    "RG9",
    "OX49",
    "OX39",
    "OX28",
    "OX29",
    "OX25",
    "OX26",
    "OX27",
    "OX20",
    "OX18",
    "OX18",
    "OX18",
    "OX15",
    "OX16",
    "OX17",
    "OX13",
    "OX14",
    "OX12",
    "OX11",
    "OX10",
    "OX9",
    "OX7",
    "OX5",
    "OX1",
    "OX2",
    "OX3",
    "OX4",
    "OX33",
    "OX44",
  ],
  Peeblesshire: ["EH46", "EH45", "EH44", "EH43"],
  Perthshire: [
    "PH15",
    "PH10",
    "PH11",
    "PH12",
    "PH13",
    "PH9",
    "PH16",
    "PH17",
    "PH18",
    "PH8",
    "PH5",
    "PH6",
    "PH7",
    "PH3",
    "PH4",
    "PH1",
    "PH2",
    "PH14",
    "FK21",
    "FK20",
    "FK19",
    "FK17",
    "FK18",
    "FK16",
    "FK15",
  ],
  Powys: [
    "SY22",
    "SY22",
    "SY22",
    "SY22",
    "SY22",
    "SY21",
    "SY20",
    "SY19",
    "SY18",
    "SY17",
    "SY17",
    "SY16",
    "SY15",
    "NP7",
    "NP8",
    "LD8",
    "LD7",
    "LD6",
    "LD5",
    "LD4",
    "LD3",
    "LD2",
    "LD1",
  ],
  Renfrewshire: [
    "PA19",
    "PA18",
    "PA15",
    "PA16",
    "PA14",
    "PA13",
    "PA12",
    "PA11",
    "PA8",
    "PA7",
    "PA5",
    "PA6",
    "PA9",
    "PA10",
    "PA4",
    "PA1",
    "PA2",
    "PA3",
  ],
  "Ross-shire": [
    "IV54",
    "IV53",
    "IV52",
    "IV40",
    "IV26",
    "IV23",
    "IV22",
    "IV21",
    "IV19",
    "IV20",
    "IV18",
    "IV17",
    "IV14",
    "IV11",
    "IV10",
    "IV9",
    "IV8",
    "IV7",
    "IV15",
    "IV16",
    "IV6",
  ],
  Roxburghshire: ["TD9", "TD9", "TD8", "TD6", "TD5"],
  Shropshire: [
    "WV15",
    "WV16",
    "TF13",
    "TF12",
    "TF11",
    "TF10",
    "TF9",
    "TF1",
    "TF2",
    "TF3",
    "TF4",
    "TF5",
    "TF6",
    "TF7",
    "TF8",
    "SY13",
    "SY12",
    "SY10",
    "SY11",
    "SY9",
    "SY8",
    "SY7",
    "SY7",
    "SY7",
    "SY6",
    "SY1",
    "SY2",
    "SY3",
    "SY4",
    "SY5",
    "SY99",
  ],
  Somerset: [
    "TA24",
    "TA23",
    "TA22",
    "TA21",
    "TA20",
    "TA19",
    "TA18",
    "TA17",
    "TA16",
    "TA15",
    "TA14",
    "TA13",
    "TA12",
    "TA11",
    "TA10",
    "TA9",
    "TA8",
    "TA5",
    "TA6",
    "TA7",
    "TA1",
    "TA2",
    "TA3",
    "TA4",
    "BS28",
    "BS27",
    "BS26",
    "BA20",
    "BA21",
    "BA22",
    "BA16",
    "BA11",
    "BA9",
    "BA10",
    "BA9",
    "BA8",
    "BA7",
    "BA6",
    "BA5",
    "BA4",
  ],
  "South Glamorgan": [
    "CF71",
    "CF64",
    "CF64",
    "CF62",
    "CF63",
    "CF61",
    "CF71",
    "CF3",
    "CF5",
    "CF10",
    "CF11",
    "CF14",
    "CF15",
    "CF23",
    "CF24",
    "CF30",
    "CF91",
    "CF95",
    "CF99",
  ],
  "South Humberside": [
    "DN40",
    "DN39",
    "DN38",
    "DN35",
    "DN31",
    "DN32",
    "DN33",
    "DN34",
    "DN36",
    "DN37",
    "DN41",
    "DN20",
    "DN19",
    "DN18",
    "DN15",
    "DN16",
    "DN17",
  ],
  "South Yorkshire": [
    "S70",
    "S71",
    "S72",
    "S73",
    "S74",
    "S75",
    "S64",
    "S60",
    "S61",
    "S62",
    "S63",
    "S65",
    "S66",
    "S1",
    "S2",
    "S3",
    "S4",
    "S5",
    "S6",
    "S7",
    "S8",
    "S9",
    "S10",
    "S11",
    "S12",
    "S13",
    "S14",
    "S17",
    "S20",
    "S21",
    "S25",
    "S26",
    "S35",
    "S36",
    "S95",
    "S96",
    "S97",
    "S98",
    "S99",
    "DN1",
    "DN2",
    "DN3",
    "DN4",
    "DN5",
    "DN6",
    "DN7",
    "DN8",
    "DN9",
    "DN10",
    "DN11",
    "DN12",
    "DN55",
  ],
  Staffordshire: [
    "WS15",
    "WS13",
    "WS14",
    "WS11",
    "WS12",
    "WS7",
    "ST16",
    "ST17",
    "ST18",
    "ST19",
    "ST20",
    "ST21",
    "ST15",
    "ST14",
    "ST13",
    "ST5",
    "ST55",
    "ST1",
    "ST2",
    "ST3",
    "ST4",
    "ST6",
    "ST7",
    "ST8",
    "ST9",
    "ST10",
    "ST11",
    "ST12",
    "DE13",
    "DE14",
    "DE15",
    "B77",
    "B78",
    "B79",
  ],
  Stirlingshire: ["FK7", "FK8", "FK9", "FK6", "FK5", "FK4", "FK3", "FK1", "FK2"],
  Suffolk: [
    "NR35",
    "NR34",
    "NR32",
    "NR33",
    "IP28",
    "IP29",
    "IP30",
    "IP31",
    "IP32",
    "IP33",
    "IP27",
    "IP21",
    "IP23",
    "IP19",
    "IP18",
    "IP17",
    "IP16",
    "IP15",
    "IP14",
    "IP12",
    "IP13",
    "IP11",
    "IP1",
    "IP2",
    "IP3",
    "IP4",
    "IP5",
    "IP6",
    "IP7",
    "IP8",
    "IP9",
    "IP10",
    "CO10",
    "CO8",
    "CB9",
    "CB8",
  ],
  Surrey: [
    "TW20",
    "TW9",
    "TW10",
    "SM7",
    "SM6",
    "SM5",
    "SM4",
    "SM1",
    "SM2",
    "SM3",
    "RH9",
    "RH8",
    "RH7",
    "RH6",
    "RH4",
    "RH5",
    "RH3",
    "RH4",
    "RH2",
    "RH1",
    "KT22",
    "KT23",
    "KT24",
    "KT21",
    "KT20",
    "KT17",
    "KT18",
    "KT19",
    "KT16",
    "KT15",
    "KT14",
    "KT13",
    "KT12",
    "KT11",
    "KT10",
    "KT9",
    "KT8",
    "KT8",
    "KT7",
    "KT5",
    "KT6",
    "KT4",
    "KT3",
    "KT1",
    "KT2",
    "GU26",
    "GU27 ",
    "GU25",
    "GU21",
    "GU22",
    "GU23",
    "GU24",
    "GU20",
    "GU19",
    "GU18",
    "GU15",
    "GU16",
    "GU17",
    "GU95",
    "GU9",
    "GU10",
    "GU7",
    "GU8",
    "GU6",
    "GU1",
    "GU2",
    "GU3",
    "GU4",
    "GU5",
    "CR8",
    "CR8",
    "CR7",
    "CR6",
    "CR5",
    "CR4",
    "CR3",
    "CR3",
    "CR2",
    "CR0",
    "CR9",
    "CR44",
    "CR90",
  ],
  Sutherland: ["KW13", "KW11", "KW10", "KW9", "KW8", "IV28", "IV27", "IV25", "IV24"],
  "Tyne and Wear": [
    "SR1",
    "SR2",
    "SR3",
    "SR4",
    "SR5",
    "SR6",
    "SR9",
    "NE40",
    "NE39",
    "NE37",
    "NE38",
    "NE36",
    "NE35",
    "NE33",
    "NE34",
    "NE32",
    "NE31",
    "NE29",
    "NE30",
    "NE28",
    "NE25",
    "NE26",
    "NE21",
    "NE8",
    "NE9",
    "NE10",
    "NE11",
    "NE92",
    "NE1",
    "NE2",
    "NE3",
    "NE4",
    "NE5",
    "NE6",
    "NE7",
    "NE12",
    "NE13",
    "NE15",
    "NE16",
    "NE17",
    "NE18",
    "NE19",
    "NE20",
    "NE27",
    "NE82",
    "NE83",
    "NE85",
    "NE88",
    "NE98",
    "NE99",
    "DH4",
    "DH5",
  ],
  Warwickshire: [
    "CV47",
    "CV37",
    "CV36",
    "CV37",
    "CV34",
    "CV35",
    "CV31",
    "CV32",
    "CV33",
    "CV21",
    "CV22",
    "CV23",
    "CV12",
    "CV10",
    "CV11",
    "CV13",
    "CV9",
    "CV8",
    "B95",
    "B80",
    "B49",
    "B50",
  ],
  "West Glamorgan": [
    "SA12",
    "SA13",
    "SA10",
    "SA11",
    "SA1",
    "SA2",
    "SA3",
    "SA4",
    "SA5",
    "SA6",
    "SA7",
    "SA8",
    "SA9",
    "SA80",
    "SA99",
  ],
  "West Midlands": [
    "WV14",
    "WV1",
    "WV12",
    "WV13",
    "WV1",
    "WV2",
    "WV3",
    "WV4",
    "WV5",
    "WV6",
    "WV7",
    "WV8",
    "WV9",
    "WV10",
    "WV11",
    "WV98",
    "WS10",
    "WS1",
    "WS2",
    "WS3",
    "WS4",
    "WS5",
    "WS6",
    "WS8",
    "WS9",
    "DY7",
    "DY8",
    "DY9",
    "DY6",
    "DY5",
    "DY4",
    "DY1",
    "DY2",
    "DY3",
    "CV1",
    "CV2",
    "CV3",
    "CV4",
    "CV5",
    "CV6",
    "CV7",
    "CV8",
    "B90",
    "B91",
    "B92",
    "B93",
    "B94",
    "B72",
    "B73",
    "B74",
    "B75",
    "B76",
    "B70",
    "B71",
    "B68",
    "B69",
    "B66",
    "B67",
    "B65",
    "B64",
    "B62",
    "B63",
    "B1",
    "B2",
    "B3",
    "B4",
    "B5",
    "B6",
    "B7",
    "B8",
    "B9",
    "B10",
    "B11",
    "B12",
    "B13",
    "B14",
    "B15",
    "B16",
    "B17",
    "B18",
    "B19",
    "B20",
    "B21",
    "B23",
    "B24",
    "B25",
    "B26",
    "B27",
    "B28",
    "B29",
    "B30",
    "B31",
    "B32",
    "B33",
    "B34",
    "B35",
    "B36",
    "B37",
    "B38",
    "B40",
    "B42",
    "B43",
    "B44",
    "B45",
    "B46",
    "B47",
    "B48",
    "B99",
  ],
  "West Sussex": [
    "RH20",
    "RH19",
    "RH16",
    "RH17",
    "RH15",
    "RH14",
    "RH12",
    "RH13",
    "RH10",
    "RH11",
    "RH77",
    "RH6",
    "PO21",
    "PO22",
    "PO18",
    "PO19",
    "PO20",
    "GU29",
    "GU28",
    "BN44",
    "BN43",
    "BN18",
    "BN16",
    "BN17",
    "BN15",
    "BN99 ",
    "BN11",
    "BN12",
    "BN13",
    "BN14",
    "BN91",
    "BN99 ",
    "BN6",
    "BN5",
  ],
  "West Yorkshire": [
    "WF17",
    "WF16",
    "WF15",
    "WF16 ",
    "WF14",
    "WF12",
    "WF13",
    "WF11",
    "WF10",
    "WF7",
    "WF8",
    "WF9",
    "WF6",
    "WF10",
    "WF5",
    "WF1",
    "WF2",
    "WF3",
    "WF4",
    "WF90",
    "LS29",
    "LS28",
    "LS22",
    "LS23",
    "LS21",
    "LS1",
    "LS2",
    "LS3",
    "LS4",
    "LS5",
    "LS6",
    "LS7",
    "LS8",
    "LS9",
    "LS10",
    "LS11",
    "LS12",
    "LS13",
    "LS14",
    "LS15",
    "LS16",
    "LS17",
    "LS18",
    "LS19",
    "LS20",
    "LS25",
    "LS26",
    "LS27",
    "LS88",
    "LS98",
    "LS99",
    "HX7",
    "HX6",
    "HX1",
    "HX5",
    "HX1",
    "HX2",
    "HX3",
    "HX4",
    "HD9",
    "HD6",
    "HD1",
    "HD2",
    "HD3",
    "HD4",
    "HD5",
    "HD7",
    "HD8",
    "BD20",
    "BD21",
    "BD22",
    "BD19",
    "BD17",
    "BD18",
    "BD98 ",
    "BD16",
    "BD97",
    "BD1",
    "BD2",
    "BD3",
    "BD4",
    "BD5",
    "BD6",
    "BD7",
    "BD8",
    "BD9",
    "BD10",
    "BD11",
    "BD12",
    "BD13",
    "BD14",
    "BD15",
    "BD98",
    "BD99",
  ],
  Wigtownshire: ["DG9", "DG8"],
  Wiltshire: [
    "SP9",
    "SP1",
    "SP2",
    "SP3",
    "SP4",
    "SP5",
    "SN16",
    "SN14",
    "SN15",
    "SN13",
    "SN15 ",
    "SN12",
    "SN11",
    "SN10",
    "SN9",
    "SN8",
    "SN1",
    "SN2",
    "SN3",
    "SN4",
    "SN5",
    "SN6",
    "SN25",
    "SN26",
    "SN38",
    "SN99",
    "BA15",
    "BA14",
    "BA13",
    "BA12",
  ],
  Worcestershire: [
    "WR15",
    "WR13",
    "WR14",
    "WR11",
    "WR12",
    "WR11",
    "WR10",
    "WR9",
    "WR1",
    "WR2",
    "WR3",
    "WR4",
    "WR5",
    "WR6",
    "WR7",
    "WR8",
    "WR78",
    "WR99",
    "DY13",
    "DY12",
    "DY10",
    "DY11",
    "DY14",
    "B96",
    "B97",
    "B98",
    "B60",
    "B61",
  ],
};

export const postcodeToCountyMapper = (postcodeDistrict: string | undefined): string => {
  if (postcodeDistrict !== undefined) {
    for (const county in pcToCountyMap) {
      const postcodeDistricts = pcToCountyMap[county as keyof typeof pcToCountyMap];
      const match = postcodeDistricts.some(
        (p: string) => postcodeDistrict.trim().toLowerCase().replace(" ", "") === p.toLowerCase()
      );
      if (match) return county;
    }
  }
  return "";
};

declare global {
  interface Window {
    postcodesToCountyMapper: any;
  }
}

window.postcodesToCountyMapper = postcodeToCountyMapper;

export default postcodeToCountyMapper;
